import React, { Component, Fragment } from 'react';
import FormCheckbox from '../_shared/forms/FormCheckbox';
import FormError from '../_shared/forms/FormError';

class ServicePriceTableRow extends Component {
    constructor(props) {
        super(props);
    }

    jobTypesExtraColumns = (id, table) => {
        if (this.props.table === 'jobTypes' && this.props.model === 'customer') {
            return (
                <Fragment>
                    <td>
                        <div className="input-group">
                            <input
                                type="number"
                                placeholder=""
                                className="form-control"
                                step="1"
                                min="1"
                                name="custom_sla"
                                value={
                                    this.props.rowData.custom_sla
                                        ? this.props.rowData.custom_sla
                                        : this.props.customerSla
                                }
                                onChange={(e) => this.props.handleJobExtrasChange(e.target, id, table)}
                                disabled={!this.props.rowData.available || this.props.readOnly}
                            />
                        </div>
                    </td>
                    <td>
                        <div className="input-group pricing-form-group">
                            <input
                                type="number"
                                placeholder=""
                                className={
                                    this.props.error.waster_journey_fee ? 'form-control is-invalid' : 'form-control'
                                }
                                step="0.01"
                                min="0"
                                name="waster_journey_fee"
                                value={
                                    this.props.rowData.waster_journey_fee ? this.props.rowData.waster_journey_fee : ''
                                }
                                onChange={(e) => this.props.handleJobExtrasChange(e.target, id, table)}
                                disabled={!this.props.rowData.available || this.props.readOnly}
                            />
                            <FormError error={this.props.error.waster_journey_fee || ''} />
                        </div>
                    </td>
                </Fragment>
            );
        }
    };

    render() {
        const { id, name, label } = this.props.rowData;
        const { table } = this.props;

        return (
            <tr>
                <td>{id}</td>
                <td>{name || label}</td>
                <td>
                    <div className="input-group pricing-form-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="input-group-prepend2">
                                &#163;
                            </span>
                        </div>
                        <input
                            type="number"
                            placeholder=""
                            name={'default_price'}
                            className={this.props.error.default_price ? 'form-control is-invalid' : 'form-control'}
                            step="0.01"
                            min="0"
                            value={
                                this.props.model === 'customer'
                                    ? this.props.rowData.default_price
                                    : this.props.rowData.provider_default_price
                            }
                            onChange={(e) => this.props.handleJobExtrasChange(e.target, id, table)}
                            disabled={!this.props.rowData.available || this.props.readOnly}
                        />
                        <FormError error={this.props.error.default_price || ''} />
                    </div>
                </td>

                {this.jobTypesExtraColumns(id, table)}

                <td className="text-center">
                    <FormCheckbox
                        name="available"
                        checked={this.props.rowData.available || false}
                        handleChange={(e) => this.props.handleJobExtrasChange(e.target, id, table)}
                        disabled={this.props.readOnly}
                    />
                </td>
            </tr>
        );
    }
}

export default ServicePriceTableRow;
